import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import logo from "../../images/dut.png";
import Button from "../../components/CustomButtons/Button.jsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import { useSpring, animated } from "react-spring";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Assignment from "@material-ui/icons/Assignment";
import Add from "@material-ui/icons/Add";

export default class Auditorias extends Component {
  constructor(props) {
    super(props);
    this.a = {
      tabHead: ["Auditor", "Sucursal", "Dirección", "Formulario", "Inicio", "Fin", "Duración", "Puntaje"],
      auditorias: [
        {
          auditor: "Juan Perez", sucursal: "Córdoba", direccion: 'Juan B Justo 2232', formulario: "Checklist Cotidiano", inicio: "17/09/19 14:24", fin: "17/09/19 15:59", duracion: 35, puntaje: '25.00', puntajeTotal: '30.00', porcentaje: 83,
          items: [
            {
              name: "Marketing",
              porcentaje: 0,
              omitido: true
            },
            {
              name: "Documentación",
              porcentaje: 72.52,
              omitido: false
            },
            {
              name: "Atención alumnos",
              porcentaje: 100,
              omitido: false
            },
            {
              name: "Asistencia",
              porcentaje: 50,
              omitido: false
            },
            {
              name: "Depósito",
              porcentaje: 100,
              omitido: false
            }
          ]
        },
        {
          auditor: "Joaquin Robles", sucursal: "Mendoza", direccion: 'Av San Martin 876', formulario: "Auditoria A1", inicio: "13/10/19 14:24", fin: "17/09/19 15:59", duracion: 35, puntaje: '38.00', puntajeTotal: '85.00', porcentaje: 45,
          items: [
            {
              name: "Marketing",
              porcentaje: 0,
              omitido: true
            },
            {
              name: "Documentación",
              porcentaje: 72.52,
              omitido: false
            },
            {
              name: "Atención alumnos",
              porcentaje: 100,
              omitido: false
            },
            {
              name: "Asistencia",
              porcentaje: 50,
              omitido: false
            },
            {
              name: "Depósito",
              porcentaje: 100,
              omitido: false
            }
          ]
        },
        {
          auditor: "Daniel Carrasco", sucursal: "Entre Ríos", direccion: 'Sarmiento 469', formulario: "Franquicias AB", inicio: "30/10/19 12:51", fin: "30/10/19 13:28", duracion: 38, puntaje: '60.00', puntajeTotal: '80.00', porcentaje: 75,
          items: [
            {
              name: "Marketing",
              porcentaje: 0,
              omitido: true
            },
            {
              name: "Documentación",
              porcentaje: 72.52,
              omitido: false
            },
            {
              name: "Atención alumnos",
              porcentaje: 100,
              omitido: false
            },
            {
              name: "Asistencia",
              porcentaje: 50,
              omitido: false
            },
            {
              name: "Depósito",
              porcentaje: 100,
              omitido: false
            }
          ]
        },
        {
          auditor: " Nadia Villarruel", sucursal: "Buenos Aires", direccion: 'Las Magnolias 754', formulario: "Auditoria 2", inicio: "25/10/19 12:32", fin: "25/10/19 13:13", duracion: 42, puntaje: '20.00', puntajeTotal: '100.00', porcentaje: 75,
          items: [
            {
              name: "Marketing",
              porcentaje: 0,
              omitido: true
            },
            {
              name: "Documentación",
              porcentaje: 72.52,
              omitido: false
            },
            {
              name: "Atención alumnos",
              porcentaje: 100,
              omitido: false
            },
            {
              name: "Asistencia",
              porcentaje: 50,
              omitido: false
            },
            {
              name: "Depósito",
              porcentaje: 100,
              omitido: false
            }
          ]
        }
      ],
      item: {}
    }
    this.state = {
      listHeader: [],
      loading: false,
      detalle: false
    }
  }

  componentDidMount() {
    this.setState({ loading: false })
  }

  _subHeader = () => {
    return (
      <Grid container spacing={0} style={{ justifyContent: "space-around", alignItems: 'center' }}>
        <Grid item xs={12} sm={6} style={{}}>
          <Typography className="novTit">Auditorias</Typography>
        </Grid>
        <Grid item xs={12} sm={6} style={{}}>
          <Link to="/editarFormulario">
            <Button style={{ paddingTop: 10, paddingBottom: 10, paddingLeft: 8, paddingRight: 8, backgroundColor: '#F50027', borderRadius: 7 }}>
              <Add className="btn3icon" />
              <Typography className="txtb3">CREAR FORMULARIO</Typography>
            </Button>
          </Link>
        </Grid>
      </Grid>
    )
  }

  _tabla = () => {
    if (!this.state.detalle) {
      return (
        <GridContainer style={{ justifyContent: 'center', alignItems: 'center' }}>
          <GridItem xs={12} sm={10}>
            <Card>
              <CardBody>
                <Table
                  striped
                  tableHead={this._dataHead()}
                  tableData={this._data()}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      )
    }
  }

  _dataHead = () => {
    const statement = [];

    for (let index = 0; index < this.a.tabHead.length; index++) {
      const element = this.a.tabHead[index];
      statement.push(
        [
          this._dataHeadItem(element)
        ]
      )
    }
    return statement;
  }

  _dataHeadItem = (item) => {
    return (
      <Typography style={{ fontSize: 12, color: '#69737D', textAlign: 'center' }}>
        {item}
      </Typography>
    )
  }

  _data = () => {
    const statement = [];

    for (let index = 0; index < this.a.auditorias.length; index++) {
      const element = this.a.auditorias[index];
      statement.push(
        [
          this._dataItem(element.auditor, index),
          this._dataItem(element.sucursal, index),
          this._dataItem(element.direccion, index),
          this._dataItem(element.formulario, index),
          this._dataItem(element.inicio, index),
          this._dataItem(element.fin, index),
          this._dataItem(element.duracion, index),
          this._dataWid(element.porcentaje, index),
        ]
      )
    }
    return statement;
  }

  _dataItem = (item, i) => {
    return (
      <Button color="primary" simple style={{ backgroundColor: '#00000000', padding: 10 }}
        onClick={() => { this._datosDetalle(i) }}>
        <Typography style={{ fontSize: 13, color: '#69737D', textTransform: 'capitalize' }}>
          {item}
        </Typography>
      </Button>
    )
  }

  _dataWid = (item, i) => {
    return (
      <div style={{ width: '100%', position: 'relative', height: 25 }}>
        <div style={{ position: 'absolute', backgroundColor: '#429cff', width: item + '%', height: '100%', borderRadius: 5 }}></div>
        <div style={{ position: 'relative', backgroundColor: '#00000000', border: '1px solid', borderColor: '#e5e5e5', height: '100%', borderRadius: 5 }}></div>
      </div>
    )
  }

  _datosDetalle = (i) => {
    this.a.item = this.a.auditorias[i];
    this.setState({ detalle: true })
  }

  _listaMiniDetalles = () => {
    const statement = [];
    for (let i in this.a.auditorias.items) {

    }
  }

  _detalle = () => {
    if (this.state.detalle) {
      return (
        <div>
          <Grid container spacing={3} style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Grid item xs={12} sm={8} style={{ width: '100%' }}>
              <Card style={{ flexDirection: 'column', width: '100%', alignItems: 'flex-start', display: 'flex', borderRadius: 10 }}>
                <CardContent onClick={() => { this.setState({ detalle: false }) }}>
                  <ArrowBack className="btn1icon" />
                </CardContent>
                <CardContent style={{ width: '100%', paddingTop: 0 }}>
                  <Grid item xs={6} style={{ justifyContent: 'flex-start' }}>
                    <Typography style={{ color: '#5a5a5a', textAlign: 'left', fontWeight: '600' }}>{this.a.item.sucursal + " | " + this.a.item.direccion}</Typography>
                  </Grid>
                  <Grid item xs={6} style={{}}>
                    <Typography style={{ fontSize: 14, fontWeight: '200', textAlign: 'left' }}>{"Supervisado por: " + this.a.item.auditor}</Typography>
                  </Grid>
                  <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                    <Grid item xs={6} style={{}}>
                      <Typography style={{ fontSize: 14, fontWeight: '200', textAlign: 'left' }}>{"Formulario: " + this.a.item.formulario}</Typography>
                    </Grid>
                    <Grid item xs={6} style={{}}>
                      <Typography style={{ fontSize: 14, fontWeight: '200', textAlign: 'right' }}>{this.a.item.puntaje + " - " + this.a.item.puntajeTotal}</Typography>
                    </Grid>
                  </div>
                  <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                    <Grid item xs={6} style={{}}>
                      <Typography style={{ fontSize: 14, fontWeight: '200', textAlign: 'left' }}>{"Fecha y hora: " + this.a.item.fin}</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ justifyContent: 'flex-end', flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                      <Typography style={{ fontSize: 14, fontWeight: '200', color: '#8cda70' }}>{'+' + this.a.item.puntaje}</Typography>
                      <Typography style={{ fontSize: 14, fontWeight: '200', textAlign: 'right', marginLeft: 5 }}>{'puntos obtenidos'}</Typography>
                    </Grid>
                  </div>
                </CardContent>
                <CardContent style={{ width: '100%', flexDirection: 'column' }}>
                  <Grid item xs={12} style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex', width: '100%', padding: 10, backgroundColor: '#fafafa', border: '1px solid', borderColor: '#e5e5e5', marginBottom: 10 }}>
                    <div>
                      <Typography style={{ fontWeight: '100', fontSize: 15, color: '#333' }}>Marketing</Typography>
                    </div>
                    <div>
                      <Typography></Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ alignItems: 'center', position: 'relative', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', width: '100%', paddingTop: 10, paddingRight: 10, paddingBottom: 10, paddingLeft: 0, backgroundColor: '#fafafa', border: '1px solid', borderColor: '#e5e5e5', marginBottom: 10 }}>
                    <div style={{ position: 'absolute', width: '72%', backgroundColor: '#f3b84c', height: 44 }}></div>
                    <div style={{ position: 'relative', paddingLeft: 10 }}>
                      <Typography style={{ fontWeight: '100', fontSize: 15, color: '#333' }}>Documentación</Typography>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Typography>{'72.52' + '%'}</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ alignItems: 'center', position: 'relative', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', width: '100%', paddingTop: 10, paddingRight: 10, paddingBottom: 10, paddingLeft: 0, backgroundColor: '#fafafa', border: '1px solid', borderColor: '#e5e5e5', marginBottom: 10 }}>
                    <div style={{ position: 'absolute', width: '100%', backgroundColor: '#c6e384', height: 44 }}></div>
                    <div style={{ position: 'relative', paddingLeft: 10 }}>
                      <Typography style={{ fontWeight: '100', fontSize: 15, color: '#333' }}>Atención alumnos</Typography>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Typography>{'100.00' + '%'}</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ alignItems: 'center', position: 'relative', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', width: '100%', paddingTop: 10, paddingRight: 10, paddingBottom: 10, paddingLeft: 0, backgroundColor: '#fafafa', border: '1px solid', borderColor: '#e5e5e5', marginBottom: 10 }}>
                    <div style={{ position: 'absolute', width: '50%', backgroundColor: '#f3b84c', height: 44 }}></div>
                    <div style={{ position: 'relative', paddingLeft: 10 }}>
                      <Typography style={{ fontWeight: '100', fontSize: 15, color: '#333' }}>Asistencia</Typography>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Typography>{'50.00' + '%'}</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} style={{ alignItems: 'center', position: 'relative', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', width: '100%', paddingTop: 10, paddingRight: 10, paddingBottom: 10, paddingLeft: 0, backgroundColor: '#fafafa', border: '1px solid', borderColor: '#e5e5e5', marginBottom: 10 }}>
                    <div style={{ position: 'absolute', width: '100%', backgroundColor: '#c6e384', height: 44 }}></div>
                    <div style={{ position: 'relative', paddingLeft: 10 }}>
                      <Typography style={{ fontWeight: '100', fontSize: 15, color: '#333' }}>Depósito</Typography>
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Typography>{'100.00' + '%'}</Typography>
                    </div>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Header />
        <Toolbar />
        <div style={{ paddingTop: window.innerWidth < 600 ? 70 : 10, paddingBottom: 70 }}>
          {this._subHeader()}
          {this._tabla()}
          {this._detalle()}
        </div>
      </React.Fragment>
    );
  }
}

function Header(props) {
  return (
    <ElevationScroll {...props}>
      <AppBar>
        <Toolbar style={{ backgroundColor: '#fff', paddingLeft: 0, paddingRight: 0 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} style={{ padding: 20, paddingBottom: 10 }}>
              <div>
                <Link to="/">
                  <img src={logo} className="App-logo" alt="logo" />
                </Link>
              </div>
            </Grid>
            <Grid
              container
              direction="row"
              justify="space-around"
              alignItems="center"
              xs={12} sm={6}
              style={{ padding: 10, flexWrap: 'nowrap', justifyContent: 'center', marginBottom: 10 }}>

              <div style={{ width: '40%', marginRight: 5 }}>
                <Link to="/">
                  <Button className="btn1" style={{ width: '100%', padding: 0, margin: 0, backgroundColor: '#fff' }}>
                    <ArrowBack className="btn1icon" style={{}} />
                    <Typography className="txtb1" style={{ fontSize: 12 }}>Seguir probando</Typography>
                  </Button>
                </Link>
              </div>
              <div style={{ width: '40%', marginLeft: 5 }}>
                <Link to="/finish">
                  <Button className="btn2" style={{ width: '100%', padding: 0, margin: 0, backgroundColor: '#F50027' }}>
                    <Typography className="txtb2">Probar 14 días gratis</Typography>
                  </Button>
                </Link>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
}
function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  });
  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
}
const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return (
    <animated.div
      ref={ref}
      style={[
        style,
        { flexDirection: "row", flex: 1, justifyContent: "center" }
      ]}
      {...other}
    >
      {children}
    </animated.div>
  );
});
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
  * Injected by the documentation to work in an iframe.
  * You won't need it on your project.
  */
  window: PropTypes.func
};